export const pricingTiers = [
  {
    id: 'silver',
    name: 'SILVER',
    price: 299,
    popular: false,
    features: [
      'Hand Wash & Dry',
      'Wheel & Tire Cleaning',
      'Interior Vacuum',
      'Dashboard & Console Wipe',
      'Window Cleaning (Interior & Exterior)',
      'Tire Shine Application',
      'Door Jamb Cleaning',
      'Basic Leather Conditioning',
      'Air Freshener',
      '2-Week Protection'
    ]
  },
  {
    id: 'gold',
    name: 'GOLD',
    price: 599,
    popular: true,
    features: [
      'Everything in Silver',
      'Clay Bar Treatment',
      'Paint Sealant Application',
      'Deep Interior Cleaning',
      'Leather Deep Conditioning',
      'Steam Cleaning Vents',
      'Engine Bay Basic Clean',
      'Headlight Polish',
      'Chrome Polishing',
      'Carpet Shampoo',
      'Pet Hair Removal',
      '3-Month Protection'
    ]
  },
  {
    id: 'platinum',
    name: 'PLATINUM',
    price: 1299,
    popular: false,
    features: [
      'Everything in Gold',
      'Paint Correction Stage 1',
      'Ceramic Coating (1 Year)',
      'Complete Engine Bay Detail',
      'Headlight Restoration',
      'Scratch Removal Service',
      'Odor Elimination Treatment',
      'Interior Sanitization',
      'Convertible Top Treatment',
      'Wheel Ceramic Coating',
      'Paint Protection Film (Partial)',
      'Trim Restoration',
      'Glass Coating',
      'Undercarriage Wash',
      '1-Year Protection'
    ]
  }
];